import { Component, Prop, Vue } from 'vue-property-decorator';
import AgendaHierarchyItemComponent from './../agenda-hierarchy-item-component/agenda-hierarchy-item-component.vue';
import HierarchyComponent from '@/shared/components/hierarchy-component/hierarchy-component.vue';
import { IHierarchyNode } from '@/shared/api-client/models/hierarchy-node';
import { IAgendaItem } from '@/shared/api-client/models/agenda/agenda-item';
import { IFileArchiveFile } from '@/shared/api-client/models/file-archive-file';
import { ArgumentValidator } from '@/shared/helpers/argument-validator';
import { Urls } from '@/shared/helpers/urls';
import { ConsoleFacade } from '@/shared/helpers/console-facade';

interface IViewModel {

    isInitialized: boolean;
}

@Component({
    components: {
        HierarchyComponent,
        AgendaHierarchyItemComponent,
    }
})
export default class AgendaItemFileAttachmentModalComponent extends Vue {

    @Prop() agendaItem!: IHierarchyNode<IAgendaItem>;
    @Prop() public translations!: { [key: string]: string; };

    public modalDomElementId = `easyvote-agenda-item-file-attachment-modal-${Math.floor((Math.random() * 99999999) + 1)}`;

    public viewModel: IViewModel = {

        isInitialized: false
    };

    public get hasFiles(): boolean {

        if (!this.agendaItem || !this.agendaItem.entity) {
            return false;
        }

        if (this.agendaItem.entity.fileArchiveFiles && this.agendaItem.entity.fileArchiveFiles.length > 0) {
            return true;
        }

        return false;
    }

    public async open($event?: MouseEvent): Promise<void> {

        if ($event) {
            $event.preventDefault();
        }

        $(`#${this.modalDomElementId}`).modal('show');

        this.viewModel.isInitialized = true;
    }

    public async close($event?: MouseEvent): Promise<void> {

        if ($event) {
            $event.preventDefault();
        }

        $(`#${this.modalDomElementId}`).modal('hide');
    }

    public downloadUrl(file: IFileArchiveFile): string {

        ArgumentValidator.notNullOrEmpty(file, `file`);

        const fileSrc = Urls.fileArchiveDownloadFile(file.id);

        ConsoleFacade.log(`Downloading file`, fileSrc);

        return fileSrc;
    }
}